module.exports = __webpack_public_path__ + "img/exclusive_feature_02.014e0f32.jpg";